import React from 'react';
import {styles} from './HeadingContainer_styles.web';
import {HeadingContainerProps} from './HeadingContainer_types.web';
import {
  contentFontStyles,
  sectionNameFontStyles,
  titleFontStyles,
} from './HeadingContainer_config.web';
import Chip from '../../Chips/Chip/Chip.web';
import {useTheme} from '../../../../utils/theming/themeProvider';
import Tooltip from '../../Tooltips/Tooltip/Tooltip.web';
import {InfoIcon} from '../../Icons/index.web';

const HeadingContainer = (
  props: React.PropsWithChildren<HeadingContainerProps>,
) => {
  // Props
  const {
    id,
    className,
    size = 'xmall',
    contentTextColor = 'grey',
    align = 'left',
    titleText,
    titleTooltip,
    contentText,
    sectionName,
    chip,
    containerStyle,
  } = props;

  // Styles
  const {colors, fontStyles} = useTheme();
  const alignItems = align !== 'left' ? 'flex-end' : 'flex-start';
  const titleFontStyle = fontStyles[titleFontStyles[size]];
  const sectionNameFontStyle = fontStyles[sectionNameFontStyles[size]];
  const contentFontStyle = fontStyles[contentFontStyles[size]];

  const contextColor =
    contentTextColor === 'grey'
      ? colors.neutral700
      : contentTextColor === 'purple'
      ? colors.primary700
      : contentTextColor === 'white'
      ? colors.neutral100
      : colors.neutral1000;

  const generalStyles = styles();

  return (
    <div
      id={id}
      className={className}
      style={{
        ...generalStyles.headingContainer,
        alignItems: alignItems,
        ...containerStyle,
      }}>
      {sectionName?.length && (
        <p
          style={{
            color:
              contentTextColor === 'white'
                ? colors.neutral100
                : colors.neutral600,
            textAlign: align,
            alignSelf: align === 'center' ? 'center' : 'flex-start',
            margin: 0,
            ...sectionNameFontStyle,
            lineHeight: sectionNameFontStyle?.lineHeight + 'px',
          }}>
          {sectionName}
        </p>
      )}
      {!!titleText?.length && (
        <div style={{...generalStyles.titleContainer}}>
          <p
            style={{
              color:
                contentTextColor === 'white'
                  ? colors.neutral100
                  : colors.neutral1000,
              textAlign: align,
              margin: 0,
              alignSelf: align === 'center' ? 'center' : 'flex-start',
              ...titleFontStyle,
              lineHeight: titleFontStyle?.lineHeight + 'px',
            }}>
            {titleText}
          </p>
          {titleTooltip && (
            <Tooltip {...titleTooltip}>
              <InfoIcon size={'16'} color={colors.neutral700} />
            </Tooltip>
          )}
        </div>
      )}

      {!!contentText?.length && (
        <p
          style={{
            color: contextColor || colors.neutral1000,
            ...contentFontStyle,
            lineHeight: contentFontStyle?.lineHeight + 'px',
            textAlign: align,
            margin: 0,
            alignSelf: align === 'center' ? 'center' : 'flex-start',
          }}>
          {contentText}
        </p>
      )}

      {chip && chip?.text && (
        <Chip
          {...chip}
          state={'enable'}
          style={'filled'}
          form={'square'}
          chipSize={'medium'}
          showText={true}
          containerStyle={{alignSelf: 'flex-start'}}
        />
      )}
    </div>
  );
};

export default HeadingContainer;
